
import HttpUtils from '../utils/HttpUtils'

export default {

  // 获取浙教云平台访问量PV
  getZjyVisitPv(){
    return HttpUtils.post("/web/access-statistics/count-pv", {
      projectCode: "qzkt_web",
    })
  },
  getAiCoursePv(){
    return HttpUtils.post("/web/access-statistics/count-pv", {
      projectCode: "qzkt_web",
      accessPath: "/ai"
    })
  },
  getAiDownload(){
    return HttpUtils.post("/web/access-statistics/count-pv", {
      projectCode: "qzkt_web",
      accessPath: "/ai",
      isDownload: 1
    })
  }
  , getAiPlatformMau(){
    return HttpUtils.post("/web/access-statistics/count-mau-recent-30days", {
      projectCode: "qzkt_web",
      accessPath: "/ai"
    })
  }
}
